define('cartware_checkout/components/advises/shippingMethod',[
	"cartware/components/_base",
	"cartware_checkout"
], function(
	Component,
	CartwareCheckout
) {
	return Component.create({
		init: function() {
			var _initialize = ShippingMethod.prototype.initialize,
				_save = ShippingMethod.prototype.save;

			ShippingMethod.prototype.initialize = function() {
				_initialize.apply(this, arguments);

				this.isSaved = false;
			};

			//ShippingMethod.prototype.save = function() {
			//	if (checkout.loadWaiting!=false) return;
			//
			//	var params = Form.serialize(this.form);
			//
			//	if (register && register.isActive()) {
			//		if (!register.validate()) return;
			//
			//		params += '&' + Form.serialize(register.getForm());
			//	}
			//
			//	if (this.validate()) {
			//		checkout.setLoadWaiting('shipping-method');
			//		var request = new Ajax.Request(
			//			this.saveUrl,
			//			{
			//				method:'post',
			//				onComplete: this.onComplete,
			//				onSuccess: this.onSave,
			//				onFailure: checkout.ajaxFailure.bind(checkout),
			//				parameters: params
			//			}
			//		);
			//	}
			//}

			ShippingMethod.prototype.nextStep = function(transport) {
				var response;

				if (transport && transport.responseText){
					try{
						response = eval('(' + transport.responseText + ')');
					}
					catch (e) {
						response = {};
					}
				}

				if (response.error) {
					alert(response.message);
					checkout.setStepResponse(response);
					return false;
				}

				if (response.blocks) {
					if (response.blocks.review) {
						$('checkout-review-wrapper').replace(response.blocks.review);
					}

					CartwareCheckout().updateProgress(response);

					//$('checkout-'+response.update_section.name+'-load').update(response.update_section.html);
				}

				checkout.setStepResponse(response);

				//payment.initWhatIsCvvListeners();

				//checkout.setShippingMethod();

				this.isSaved = true;

				if ("accordion" in window) {
					setTimeout(function() {
						window.accordion._layout();
					}, 100);
				}
			}
		}
	});
});
